"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockServices = void 0;
var api_1 = require("../../api");
var models_mock_1 = require("../../api/models/mocks/models.mock");
var dp_testing_lib_1 = require("@greatmindsorg/dp-testing-lib");
var mockServices = function (partial) {
    if (partial === void 0) { partial = {}; }
    return new api_1.ServiceContextState(__assign({ assessmentPerformanceService: (0, dp_testing_lib_1.mock)({
            getStudentsAssessmentPerformanceByClassAndTemplate: jest.fn().mockResolvedValue([]),
            getAssessmentPerformanceByStudent: jest.fn().mockResolvedValue([]),
            getOverallStudentAssessmentPerformance: jest.fn().mockResolvedValue([]),
        }), assessmentTemplateService: (0, dp_testing_lib_1.mock)({
            findOne: jest.fn().mockResolvedValue((0, models_mock_1.mockAssessmentTemplate)()),
            findByOwner: jest.fn().mockResolvedValue([]),
            publish: jest.fn(),
            copy: jest.fn(),
            sync: jest.fn(),
            rename: jest.fn(),
            createCustom: jest.fn().mockResolvedValue((0, models_mock_1.mockAssessmentTemplate)()),
            editCustom: jest.fn(),
            mergeAssessmentTemplatesStandards: jest.fn().mockResolvedValue([]),
        }), assessmentTemplateSearchService: (0, dp_testing_lib_1.mock)({
            searchByCurriculum: jest.fn().mockResolvedValue([]),
            suggest: jest.fn().mockResolvedValue([]),
        }), assessmentTemplateUsageService: (0, dp_testing_lib_1.mock)({
            getAssessmentTemplateUsage: jest.fn().mockResolvedValue([(0, models_mock_1.mockAssessmentTemplateUsage)()]),
        }), assessmentService: (0, dp_testing_lib_1.mock)({
            findByOwner: jest.fn().mockResolvedValue([]),
            findByCurrentUser: jest.fn().mockResolvedValue([]),
            assign: jest.fn(),
            open: jest.fn(),
            finish: jest.fn(),
            findOne: jest.fn().mockResolvedValue((0, models_mock_1.mockAssessment)()),
            reassign: jest.fn(),
            stop: jest.fn(),
            delete: jest.fn(),
            mergeClasses: jest.fn().mockResolvedValue([(0, models_mock_1.mockAssessment)()]),
        }), attemptService: (0, dp_testing_lib_1.mock)({
            findByAssignee: jest.fn().mockResolvedValue([]),
            findAvailableByAssignee: jest.fn().mockResolvedValue([]),
            findByAssessment: jest.fn().mockResolvedValue([]),
            start: jest.fn(),
            findOne: jest.fn().mockResolvedValue((0, models_mock_1.mockAttempt)()),
            submit: jest.fn(),
            sync: jest.fn(),
            upsertFeedback: jest.fn().mockResolvedValue((0, models_mock_1.mockAttempt)()),
            grade: jest.fn().mockResolvedValue((0, models_mock_1.mockAttempt)()),
            getAttemptFeedback: jest.fn().mockResolvedValue((0, models_mock_1.mockAttempt)()),
            mergeAssignees: jest.fn().mockResolvedValue([(0, models_mock_1.mockAttempt)()]),
            mergeClasses: jest.fn().mockReturnValue([(0, models_mock_1.mockAttempt)()]),
        }), analyticsService: (0, dp_testing_lib_1.mock)({
            getAssessmentPerformanceByClass: jest.fn().mockResolvedValue([]),
            getAssessmentPerformanceByClassAndAssignee: jest.fn().mockResolvedValue([]),
            getAssessmentsPerformanceBandDistribution: jest.fn().mockResolvedValue([]),
            getAssigneesPerformancesByClassAndTemplate: jest.fn().mockResolvedValue([]),
            getClassPerformanceByClassAndTemplate: jest.fn().mockResolvedValue([]),
            getItemsPerformanceByAssessment: jest.fn().mockResolvedValue([]),
            getItemsPerformanceByContextAndTemplate: jest.fn().mockResolvedValue([]),
            getMostRecentAssessedStandardDate: jest.fn().mockResolvedValue(new Date()),
            getOverallStandardPerformanceByClassAndTemplate: jest.fn().mockResolvedValue([]),
            getOverallStandardPerformanceByClassAndAssignee: jest.fn().mockResolvedValue([]),
            getOverallStandardPerformanceBandDistribution: jest.fn().mockResolvedValue([]),
            getStandardsPerformanceBandDistribution: jest.fn().mockResolvedValue([]),
        }), assigneePerformanceService: (0, dp_testing_lib_1.mock)({
            getAssigneesPerformancesByClassAndTemplate: jest.fn().mockResolvedValue([]),
            getOverallAssigneesPerformanceWW: jest.fn().mockResolvedValue((0, models_mock_1.mockAssigneePerformanceWW)()),
            getItemQuestionsPerformance: jest.fn().mockResolvedValue([]),
            getStudentAssessmentPerformancesByClassAndTemplateAndStandard: jest
                .fn()
                .mockResolvedValue([]),
        }), authService: (0, dp_testing_lib_1.mock)({
            logout: jest.fn(),
            refresh: jest.fn(),
            getRoles: jest.fn().mockResolvedValue((0, models_mock_1.mockRoles)()),
            updateActiveRole: jest.fn(),
        }), classPerformanceService: (0, dp_testing_lib_1.mock)({
            getClassPerformanceByContext: jest.fn().mockResolvedValue([]),
            getAssessmentPerformances: jest.fn().mockResolvedValue([]),
        }), classService: (0, dp_testing_lib_1.mock)({
            findByOwner: jest.fn().mockResolvedValue([]),
            findByCurrentUser: jest.fn().mockResolvedValue([]),
            findByIds: jest.fn().mockResolvedValue([]),
            findOneById: jest.fn().mockResolvedValue((0, models_mock_1.mockClass)()),
        }), configurationService: (0, dp_testing_lib_1.mock)({
            getConfiguration: jest.fn().mockResolvedValue((0, models_mock_1.mockCurriculum)()),
        }), curriculumService: (0, dp_testing_lib_1.mock)({
            mergeAssessmentTemplates: jest.fn().mockResolvedValue((0, models_mock_1.mockCurriculum)()),
            trimCurriculum: jest.fn().mockResolvedValue((0, models_mock_1.mockCurriculum)()),
        }), itemQuestionPerformanceService: (0, dp_testing_lib_1.mock)({
            getItemAnalysisByClassAndAssessment: jest.fn().mockResolvedValue([]),
        }), learnosityService: (0, dp_testing_lib_1.mock)({
            signPreviewAssessmentRequest: jest.fn().mockResolvedValue({ id: 1 }),
            signReviewAttemptRequest: jest.fn().mockResolvedValue({ id: 1 }),
            signPreviewRubricRequest: jest.fn().mockResolvedValue({ id: 1 }),
            signEditAssessmentTemplateRequest: jest.fn().mockResolvedValue({ id: 1 }),
            signViewAssessmentTemplateRequest: jest.fn().mockResolvedValue({ id: 1 }),
            signPlayAttemptRequest: jest.fn().mockResolvedValue({ id: 1 }),
            signMonitorAssessmentRequest: jest.fn().mockResolvedValue({ id: 1 }),
            signStudentDetailReportRequest: jest.fn().mockResolvedValue({ id: 1 }),
        }), multipleAssessmentsPerformanceService: (0, dp_testing_lib_1.mock)({
            getAverageScoreByTemplate: jest.fn().mockResolvedValue([]),
            getAverageMinutesByTemplate: jest.fn().mockResolvedValue([]),
            getOverallAssigneeAssessmentPerformances: jest
                .fn()
                .mockResolvedValue((0, models_mock_1.mockAssigneeAssessmentPerformance)()),
        }), performanceBandService: (0, dp_testing_lib_1.mock)({
            findByCurriculum: jest.fn().mockResolvedValue([]),
        }), settingService: (0, dp_testing_lib_1.mock)({
            createUserSetting: jest.fn(),
            update: jest.fn(),
            updateDistrictSettings: jest.fn(),
            findByUserAndCurriculum: jest.fn().mockResolvedValue((0, models_mock_1.mockSettingOptions)()),
            findDistrictByCurriculumList: jest.fn().mockResolvedValue([]),
        }), standardSetService: (0, dp_testing_lib_1.mock)({
            findAll: jest.fn().mockResolvedValue([]),
            findStandardSetGlobalIdByCurriculum: jest.fn().mockResolvedValue([]),
        }), summaryService: (0, dp_testing_lib_1.mock)({
            getAssessmentCompletionSummaryByClassAndTemplate: jest
                .fn()
                .mockResolvedValue((0, models_mock_1.mockAssessmentCompletionSummary)()),
            getAssessmentCompletionSummaryByClassAndAssignee: jest
                .fn()
                .mockResolvedValue((0, models_mock_1.mockAssessmentCompletionSummary)()),
            getCountPriorAssessments: jest.fn().mockResolvedValue(2),
        }), userService: (0, dp_testing_lib_1.mock)({
            findByClass: jest.fn().mockResolvedValue([]),
            findByIds: jest.fn().mockResolvedValue([]),
            findCurrent: jest.fn().mockResolvedValue((0, models_mock_1.mockUser)()),
            findOne: jest.fn().mockResolvedValue((0, models_mock_1.mockUser)()),
        }), foundationalService: (0, dp_testing_lib_1.mock)({
            findByCode: jest.fn().mockResolvedValue([(0, models_mock_1.mockFoundational)()]),
        }), recommendationsService: (0, dp_testing_lib_1.mock)({
            findByExternalTemplateIdAndExternalItemId: jest
                .fn()
                .mockResolvedValue([(0, models_mock_1.mockRecommendation)()]),
        }), userLevelSettingsService: (0, dp_testing_lib_1.mock)({
            upsertUserSettings: jest.fn(),
            getOwnUserSettings: jest.fn().mockResolvedValue((0, models_mock_1.mockUserLevelSettings)()),
            getStudentUserSettings: jest.fn().mockResolvedValue([(0, models_mock_1.mockUserLevelSettings)()]),
        }), rubricRatingService: (0, dp_testing_lib_1.mock)({
            findByContextAndAssessment: jest.fn().mockResolvedValue([(0, models_mock_1.mockRubricRating)()]),
        }), schoolService: (0, dp_testing_lib_1.mock)({
            findByAdmin: jest.fn().mockResolvedValue([(0, models_mock_1.mockSchool)()]),
        }), adminSearchService: (0, dp_testing_lib_1.mock)({
            findAssessmentTemplates: jest.fn().mockResolvedValue([(0, models_mock_1.mockAdminSearchTemplate)()]),
        }), reportFilesService: (0, dp_testing_lib_1.mock)({
            exists: jest.fn().mockResolvedValue(true),
            download: jest
                .fn()
                .mockResolvedValue({ buffer: Buffer.alloc(15, 'test', 'utf-8'), fileName: 'test-file' }),
        }), assigneeUsageService: (0, dp_testing_lib_1.mock)({
            findUnattemptedAssigneesByContextAndTemplate: jest.fn().mockResolvedValue([]),
        }), standardHierarchyLevelService: (0, dp_testing_lib_1.mock)({
            fetchHierarchyLevelsByCurriculum: jest.fn().mockResolvedValue([]),
        }), schoolYearService: (0, dp_testing_lib_1.mock)({
            findByDistrict: jest.fn().mockResolvedValue([(0, models_mock_1.mockSchoolYear)()]),
            findCurrent: jest.fn().mockResolvedValue((0, models_mock_1.mockSchoolYear)()),
        }), customRubricService: (0, dp_testing_lib_1.mock)({
            upsertAttemptRubricSelection: jest.fn(),
        }) }, partial));
};
exports.mockServices = mockServices;
